import { environment } from '@environments/environment';
import { WORKSPACE_LAB_AVD_BASE_URL } from './workspace-lab-avd.constants';

/**
 * AC1 — Mapa ESTÁTICO (em código) de rota → template de URL de lançamento do módulo executável (AVD).
 *
 * - A URL leva `?tenant={tenantId}` (direciona o web client ao Entra que hospeda o AVD) em vez de
 *   pré-preencher o e-mail do usuário — que pode ser identidade externa/B2B sem acesso ao AVD.
 * - É a fonte de verdade de "esta rota é um módulo executável?" (AC3) e o **fallback** de URL.
 * - A URL PRECISA por módulo/tenant continua vindo do backend (`externalLaunchUrlTemplate`,
 *   resolvida dinamicamente e auto-curável). Quando o backend tem a URL, ela tem prioridade;
 *   sem ela, cai neste mapa (retrocompat: feed do AVD — mesmo destino do Módulo Autolac).
 * - Disponível imediatamente, sem cadastro/admin (AC2).
 */
const AVD = `${WORKSPACE_LAB_AVD_BASE_URL}?tenant=${environment.auth.sso.tenantId}`;

export const EXECUTABLE_MODULE_LAUNCH_URLS: Readonly<Record<string, string>> = {
  '/autolac': AVD,
  '/atendimento': AVD,
  '/financeiro': AVD,
  '/estoque': AVD,
  '/urgencia': AVD,
  '/interlac': AVD,
  '/confere': AVD,
  '/laudos-web': AVD,
  '/integre': AVD,
};

function normalizeRoute(route?: string | null): string | null {
  if (!route) return null;
  const r = route.trim().toLowerCase().split('?')[0];
  return r.length > 0 ? r : null;
}

/** AC3 — a rota corresponde a um módulo executável (abre AVD em nova aba)? */
export function isExecutableModuleRoute(route?: string | null): boolean {
  const r = normalizeRoute(route);
  return !!r && Object.prototype.hasOwnProperty.call(EXECUTABLE_MODULE_LAUNCH_URLS, r);
}

/** Resolve a URL de lançamento pelo mapa estático, substituindo `{userEmail}` (AC4). */
export function resolveExecutableModuleLaunchUrl(route?: string | null, email?: string): string | null {
  const r = normalizeRoute(route);
  if (!r) return null;
  const template = EXECUTABLE_MODULE_LAUNCH_URLS[r];
  if (!template) return null;
  return template.split('{userEmail}').join(encodeURIComponent(email ?? ''));
}

// ── AC12 — módulos removidos do menu lateral ──────────────────────────────────
const REMOVED_MENU_MODULE_ROUTES = new Set<string>(['/interlac', '/confere', '/laudos-web', '/integre']);
const REMOVED_MENU_MODULE_KEYS = new Set<string>(['interlac', 'confere', 'laudos_web', 'integre']);

/** True se o item (por rota OU key) é um dos módulos removidos do menu (Interlac/Laudos Web/Confere/Integre). */
export function isRemovedMenuModule(route?: string | null, key?: string | null): boolean {
  const r = normalizeRoute(route);
  if (r && REMOVED_MENU_MODULE_ROUTES.has(r)) return true;
  const k = key?.trim().toLowerCase();
  return !!k && REMOVED_MENU_MODULE_KEYS.has(k);
}
